import Cookies from 'js-cookie'
import Vue from '../../btnPermission'
import router from '@/router'
import store from '@/vuex'
import '../hsiconfont/iconfont.js'
export function downloadExcel (url, params, name) {
  Vue.prototype.$axios.get(url, {
    params,
    responseType: 'blob'
  }).then((response) => {
    if (!response) {
      return
    }
    let url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.ms-excel'}))
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    if(name){
      link.setAttribute('download', name +'.xls')
    } else {
      link.setAttribute('download', 'excel.xls')
    }
    
    document.body.appendChild(link)
    link.click()
  })
}

export function getQueryString (name) { // 获取地址栏参数
  var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if(r!=null)return  unescape(r[2]); return null;
}

export default {
  pageGoBack (vue, routeName) {
    vue.$router.push({name: '/' + routeName})
    let tabItem = store.getters.rightNav
    store.dispatch('removeTab', {tabItem, fullPath: vue.$router.fullPath, router: vue.$router})
  },
  formatTimeToDate (time) {
    return new Date(time).format("yyyy-MM-dd hh:mm");
  },
  formatTimeToDay (time) {
    return new Date(time).format("yyyy-MM-dd");
  },
}

Date.prototype.format = function (format) {
  var date = {
		"M+": this.getMonth() + 1,
		"d+": this.getDate(),
		"h+": this.getHours(),
		"m+": this.getMinutes(),
		"s+": this.getSeconds(),
		"q+": Math.floor((this.getMonth() + 3) / 3),
		"S+": this.getMilliseconds()
	};
	if (/(y+)/i.test(format)) {
		format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
	}
	for (var k in date) {
		if (new RegExp("(" + k + ")").test(format)) {
			format = format.replace(RegExp.$1, RegExp.$1.length == 1
				? date[k] : ("00" + date[k]).substr(("" + date[k]).length));
		}
	}
	return format;
}


// 复制链接
export function copyLink(link) {
  if (navigator.clipboard) {
    // 现代浏览器
    navigator.clipboard.writeText(link)
      .then(() => {
        console.log('链接已复制到剪贴板:', link);
        alert('链接已复制！');
      })
      .catch((err) => {
        console.error('复制失败:', err);
        fallbackCopy(link); // 降级方案
      });
  } else {
    // 旧版浏览器
    fallbackCopy(link);
  }
}

function fallbackCopy(link) {
  const input = document.createElement('input');
  input.value = link;
  document.body.appendChild(input);
  input.select();
  try {
    document.execCommand('copy');
    console.log('链接已复制到剪贴板:', link);
    alert('链接已复制！');
  } catch (err) {
    console.error('复制失败:', err);
    alert('复制失败，请手动复制链接。');
  } finally {
    document.body.removeChild(input);
  }
}

export function convertDayHour(milliseconds) {
  // 将毫秒转换为秒
  let seconds = Math.floor(milliseconds / 1000);

  // 计算天数
  let days = Math.floor(seconds / (3600 * 24));
  seconds = seconds % (3600 * 24);

  // 计算小时
  let hours = Math.floor(seconds / 3600);
  seconds = seconds % 3600;

  // 计算分钟
  let minutes = Math.floor(seconds / 60);

  // 返回结果
  return {
      days: days,
      hours: hours,
      minutes: minutes
  };
}

export function crossOriginDownload(url, filename) {

  fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = URL.createObjectURL(blob)
      console.log(link.href)
      link.download = filename || ''
      document.body.appendChild(link)
      link.click()
  })
  return
    // 1. 发起跨域请求获取文件
    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error('网络响应不正常');
        }
        return response.blob();
      })
      .then(blob => {
        // 2. 创建Blob URL
        const blobUrl = URL.createObjectURL(blob);
        
        // 3. 创建隐藏的<a>标签
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = blobUrl;
        a.download = filename || getFilenameFromUrl(url);
        
        // 4. 触发下载
        document.body.appendChild(a);
        a.click();
        
        // 5. 清理
        setTimeout(() => {
          document.body.removeChild(a);
          URL.revokeObjectURL(blobUrl);
        }, 100);
      })
      .catch(error => {
        console.error('下载失败:', error);
        // 降级方案：新窗口打开
        window.open(url, '_blank');
      });

    // 从URL提取文件名
    function getFilenameFromUrl(url) {
      return decodeURIComponent(
        url.split('/').pop()          // 获取最后一部分
          .split('#')[0]            // 去掉hash
          .split('?')[0]            // 去掉query
          .replace(/[^\w.-]/g, '_') // 替换非法字符
      ) || 'download';
    }
  }
      /**
    * @description: 输入User对象,获取背景颜色
    * @param  User
    * @return: User对象
    */
export  function  getUserColor(User={},userName=''){
  let username=userName||User.name||User.nameCn||User.userName||User.applyUserName || User.staffName||'';
  let usernameNumber=username.split('').reduce((total, num)=>total+num.charCodeAt(0),0);
  let colorList = ['#0cc0c9', '#ffab24', '#2e9cff', '#ff6952']
  let colorList2 = ['rgba(12, 192, 201,.3)', 'rgba(255, 171, 36,.3)', 'rgba(46, 156, 255,.3)', 'rgba(255, 105, 82,.3)']
  let backgroundColor=colorList[usernameNumber%colorList.length];
  let BoxShadowColor=colorList2[usernameNumber%colorList2.length];
  User.backgroundColor=backgroundColor;
  User.BoxShadowColor=BoxShadowColor;
  return User;
}



// WEBPACK FOOTER //
// ./src/assets/common/common.js